<template>
  <div class="kanit cancelitem cancel-the-item line-template-consign">
    <div class="group-box select-item px-3">
        เลือกรายการที่ต้องยกเลิก
    </div>
    <div class="d-flex flex-column">
        <div v-for="(item,index) in orders" :key="index" class="group-box paddingY-group-8px row w-100 ml-0 mr-0 px-3" :class="[index !== 0 ? 'mt-2' : '']">
            <div class="col-10">
                <h3 class="header-text"><b>{{ index+1 }}.{{ item.to_name}}</b> | {{ maskPhoneNumber(item.to_tel.toString()) }}</h3>
                <p class="description">
                    {{  item.to_address }} {{ item.to_state }} {{ item.to_district }} {{ item.to_province }} {{ item.to_postcode }} 
                </p>
            </div>
            <div class="col-2">
                <div class="position-absolute pencil-edit">
                    <img :src="icon.penceilEdit.url" alt="pancil" @click="editOrder(item.id)">
                </div>
                <div class="position-absolute trash-icon">
                    <img :src="icon.trash.url" alt="trash" @click="deleteOrder('SELECTED', item.id, orders.length)">
                </div>
            </div>
            <div v-if="item.remark" class="col-12">
                <hr class="border-dash">
                <div class="d-flex">
                    <div class="col-2 header-remark">                        
                        หมายเหตุ
                    </div>
                    <div class="col-10 detail-remark text-line-muted">
                        {{  item.remark }}
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3 pt-3 px-3 group-box pb-3 fixed-bottom">
            <b-button class="hover-button" variant="outline-line-primary" block @click="closeToChat()">
                กลับสู่ Chat
            </b-button>
        </div>
    </div>
    <b-modal
        no-close-on-esc
        body-class="custom-padding"
        no-close-on-backdrop
        hide-footer
        v-model="deletePOPUP" 
        id="modal-center" 
        centered
        hide-header
    >
    <div class="custom-header-cancel">
        <div class="d-flex justify-content-between">
            <h2 class="font-size-cancel">ยืนยันการยกเลิกข้อมูล</h2>
            <span class="close cursor-pointer" @click="close()">&times;</span>
        </div>
    </div>
    <div class="custom-body-cancel">
        <div>
            <p class="description">
                หากยกเลิกข้อมูลแล้วจะไม่สามารถเรียกคืนได้ ต้องการยกเลิกหรือไม่?
            </p>
            <hr class="line-setting">
            <div class="d-flex justify-content-between">
                <div class="w-100 pr-1">
                    <b-button variant="outline-line-primary" block @click="close">
                        ปิดหน้าต่าง
                    </b-button>
                </div>
                <div class="w-100 pl-1">
                    <b-button variant="line-primary" block @click="confirmOrder">
                        ยืนยัน
                    </b-button>
                </div>
            </div>
        </div> 
    </div>  
    </b-modal>
  </div>
</template>

<script>
const context_line = JSON.parse(localStorage.getItem('context_line'))
export default {
    data() {
        return {
            orders: [],
            draftId: '',
            icon: {
                trash: {
                    url: require("../../assets/icon/delete.svg")
                },
                penceilEdit: {
                    url: require("../../assets/icon/penciledit.svg")
                },
                close: {
                    url: require("../../assets/icon/close.svg")
                }
            },
            messageAlert: '',
            dismissCountDown: 0,
            deletePOPUP: false,
            tempIdDelete: '',
            tempType: '',
            lengthOrder: null,
        }
    },
    methods: {
        closeToChat() {
            this.$liff.closeWindow()
        },
        close() {
            this.deletePOPUP = false
        },
        confirmOrder() {
            const body = {
                type: this.lengthOrder === 1 ? 'ALLDRAFT': this.tempType,
                draft_order_item_id: this.tempIdDelete
            }
            const headers = {
                headers: {
                  Token: localStorage.getItem('access_token_customer')
                }
            }
            if(this.tempType === 'ALLDRAFT') {
                this.$http.post(this.$API_URL + `/line/cancel/draftorder/${this.draftId}`, body, headers).then((res) => {
                const status = res.data.status
                if(!status) {
                    this.showAlert();
                    this.messageAlert = 'ไม่สามารถลบข้อมูลได้'
                }
                }).finally(() => {
                    this.getDraftOrder()
                    this.deletePOPUP = false
                    this.$liff.closeWindow()
                })
            }else if (this.tempType === 'SELECTED') {
                this.$http.post(this.$API_URL + `/line/cancel/draftorder/${this.draftId}`, body, headers).then((res) => {
                const status = res.data.status
                if(!status) {
                    this.showAlert();
                    this.messageAlert = 'ไม่สามารถลบข้อมูลได้'
                }
                }).finally(() => {
                    this.getDraftOrder()
                    this.deletePOPUP = false
                })
            }
        },
        editOrder(key) {
            this.$router.push({ path: '/line/edit/consign', query: { consignId: key , draftId: this.$route.query.draftId, typeSelect: this.$route.query.typeSelect } })
        },
        showAlert() {
            this.dismissCountDown = 5
        },  
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        maskPhoneNumber(number) {
            const lastFourDigits = number.substr(-4);
            return "******" + lastFourDigits;
        },
        getDraftOrder() {
            const getProfile = JSON.parse(localStorage.getItem('profile_line'))
            const body = {
                access_token: localStorage.getItem('access_token_line'),
                userId: getProfile.sub
            }
            const headers = {
                headers: {
                  Token: localStorage.getItem('access_token_customer')
                }
            }
            this.$http.post(this.$API_URL + `/line/get/draftorder/${this.draftId}`, body, headers).then((res) => {
                const status = res.data.status
                if(!status) {    
                    return this.$router.push('/location/timeout')
                }
                this.orders = res.data.data
                console.log('length: ', this.orders.length)
            })
        },
        deleteOrder(type, orderid, lengthDelete) {
            this.tempIdDelete = orderid
            this.tempType = type
            this.deletePOPUP = true
            this.lengthOrder = lengthDelete
        }
    },
    mounted() {
        // this.$liff.init({
        //     liffId: context_line.liffId
        // })
        this.draftId = this.$route.query.draftId ? this.$route.query.draftId : ''
        if(!this.draftId) {
            return this.$router.push('/location/timeout')
        }
        this.getDraftOrder()
    }
}
</script>